<template>
  <div>
    <b-modal id="modalEditFirewallsSetting" ref="modalEditFirewallsSetting" :title="$t('Firewalls')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.type" :options="type"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" label="IP" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.address"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.login"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Comments')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.comments"/>
        </b-form-group>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditFirewallsSetting')" />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      type: [
        {text: this.$i18n.t('Local'), value: 0},
        {text: this.$i18n.t('Remote cisco'), value: 1}
      ]
    }
  },
  methods: {
    validationIP () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.editItem.address.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      if (this.editItem.address) {
        if (!this.validationIP()) {
          return
        }
      }
      this.editItem.router_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_FIREWALLS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_FIREWALLS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_FIREWALLS')
          this.$refs.modalEditFirewallsSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/firewalls/editModal.vue